var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65927 2.85711H15.3574M9.65925 6.85711H15.3574M1.64307 10.8571H15.3574M1.64307 14.8571H15.3574M1.64307 6.85711L3.39725 1.59457C3.48717 1.32479 3.73964 1.14282 4.02401 1.14282C4.30839 1.14282 4.56086 1.32479 4.65079 1.59457L6.40497 6.85711M2.27811 4.95232H5.77017",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgText as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05LjY1OTI3IDIuODU3MTFIMTUuMzU3NE05LjY1OTI1IDYuODU3MTFIMTUuMzU3NE0xLjY0MzA3IDEwLjg1NzFIMTUuMzU3NE0xLjY0MzA3IDE0Ljg1NzFIMTUuMzU3NE0xLjY0MzA3IDYuODU3MTFMMy4zOTcyNSAxLjU5NDU3QzMuNDg3MTcgMS4zMjQ3OSAzLjczOTY0IDEuMTQyODIgNC4wMjQwMSAxLjE0MjgyQzQuMzA4MzkgMS4xNDI4MiA0LjU2MDg2IDEuMzI0NzkgNC42NTA3OSAxLjU5NDU3TDYuNDA0OTcgNi44NTcxMU0yLjI3ODExIDQuOTUyMzJINS43NzAxNyIKICAgICAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";